import React, { useRef, useEffect, useState } from "react";
import loveEmoji from "../../assets/love-emoji-3d 1.png";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const FAQItem = ({ item, index, isVisible }) => {
  const [itemVisible, setItemVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setItemVisible(true);
      }, index * 100);
      return () => clearTimeout(timer);
    }
  }, [isVisible, index]);

  return (
    <div 
      className={`border-b border-black py-3 sm:py-4 md:py-5 lg:py-6 transition-all duration-500 hover:bg-gray-100/50 ${
        itemVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
    >
      <div className="flex flex-col md:flex-row md:items-start gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
        <h3 className="text-ag-black-900 font-bold text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-left md:w-1/2 hover:text-ag-purple transition-colors duration-300">
          {item.question}
        </h3>
        <div className="text-ag-black-900 font-medium text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl 2xl:text-2xl leading-relaxed whitespace-pre-line md:w-1/2">
          {item.answer}
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.5 });
  const { ref: faqListRef, isVisible: faqListVisible } = useScrollAnimation({ threshold: 0.1 });

  const faqData = [
    {
      id: 1,
      question: "Can I customize the templates?",
      answer:
        "Yes! Change colors, text, images, and even more dynamic options.",
    },
    {
      id: 2,
      question: "Can I request custom animations based on your templates?",
      answer:
        "We gladly accept requests, though we can't guarantee every one will be developed.\nIf you want something more custom, consider joining our Cohorts Program — where we create templates tailored specifically for you.",
    },
    {
      id: 3,
      question: "Can I use these templates on monetized YouTube videos?",
      answer:
        "Yes, all templates come with commercial-use rights so you can post, and share freely.",
    },
    {
      id: 4,
      question: "Are your templates copyright-safe?",
      answer:
        "100%. We design everything with original assets so you're protected from strikes and takedowns.",
    },
    {
      id: 5,
      question: "I'm new to this — are the templates beginner-friendly?",
      answer: "Totally. No animation skills required.",
    },
    {
      id: 6,
      question: "Do you offer subscriptions or single-template purchases?",
      answer:
        "Most of our Motion templates are free, but we offer subscriptions for more premium access and Ai generation.",
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="bg-black py-8 sm:py-12 md:py-16 lg:py-20 xl:py-24 2xl:py-28">
        <div 
          ref={titleRef}
          className="mx-auto px-3 sm:px-4 md:px-5 lg:px-6 xl:px-8 text-center relative "
        >
          <p className={`font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-7xl text-ag-green px-2 transition-all duration-700 ${
            titleVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"
          }`}>
            Frequently Asked Questions (FAQs)
          </p>
          <img
            src={loveEmoji}
            alt="Love emoji"
            className={`absolute left-[70%] sm:left-[72%] md:left-[75%] xl:left-[80%] top-[-50%] sm:top-[-60%] md:top-[-80%] lg:top-[-100%] xl:top-[-120%] w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 lg:w-48 lg:h-48 xl:w-56 xl:h-56 2xl:w-60 2xl:h-60 z-[3] pointer-events-none transition-all duration-700 ${
              titleVisible ? "opacity-100 rotate-0" : "opacity-0 rotate-12"
            }`}
            style={{ animation: titleVisible ? 'floatGentle 5s ease-in-out infinite' : 'none', transitionDelay: '300ms' }}
          />
        </div>
      </div>
      <div className="bg-ag-white-300">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-5 lg:px-6 xl:px-8">
          <div ref={faqListRef} className="space-y-2 sm:space-y-3 md:space-y-4 py-4 sm:py-5 md:py-6">
            {faqData.map((item, index) => (
              <FAQItem 
                key={item.id} 
                item={item} 
                index={index}
                isVisible={faqListVisible}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
